import React from "react";
import withStyles from "@material-ui/styles/withStyles";
import { Container, Grid, Typography } from "@material-ui/core";

import img from "./Contact/img-person.jpg";

import { styles } from "./Contact.styles";

function Contact({ classes }) {

  return (
    <Container maxWidth="md" className={classes.root}>
      <Grid container>
        <Grid item xs={4}>
          <img src={img} className={classes.photo} alt="alt" />
          <Typography className={classes.name}>Alexandre Silva</Typography>
          <Typography className={classes.description}>
            Proin integer ac, aliquam nesciunt deleniti officia, culpa culpa
            semper, pharetra elementum ullamcorper! Blandit, libero massa?
            Mattis fugit rhoncus proident ullam nonummy reiciendis, augue,
            curae.
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <img src={img} className={classes.photo} alt="alt" />
          <Typography className={classes.name}>Manuel Lourenço</Typography>
          <Typography className={classes.description}>
            Proin integer ac, aliquam nesciunt deleniti officia, culpa culpa
            semper, pharetra elementum ullamcorper! Blandit, libero massa?
            Mattis fugit rhoncus proident ullam nonummy reiciendis, augue,
            curae.
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <img src={img} className={classes.photo} alt="alt" />
          <Typography className={classes.name}>Simão Peca</Typography>
          <Typography className={classes.description}>
            Proin integer ac, aliquam nesciunt deleniti officia, culpa culpa
            semper, pharetra elementum ullamcorper! Blandit, libero massa?
            Mattis fugit rhoncus proident ullam nonummy reiciendis, augue,
            curae.
          </Typography>
        </Grid>
        <Typography className={classes.contact}>Contacte-nos para mais informações:</Typography>
        <a href="mailto:info@solarpunk.pt" className={classes.link}>info@solarpunk.pt</a>
      </Grid>
    </Container>
  );
}

export default withStyles(styles)(Contact);
